import type { SVGProps } from "react";
export interface ModemIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ModemIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ModemIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 15.5c0-1.036-.84-1.875-1.875-1.875H5c-1.036 0-1.875.84-1.875 1.875v2c0 1.035.84 1.875 1.875 1.875h14c1.035 0 1.875-.84 1.875-1.875zm2.25 2A4.125 4.125 0 0 1 19 21.625H5A4.125 4.125 0 0 1 .875 17.5v-2A4.125 4.125 0 0 1 5 11.375h14a4.125 4.125 0 0 1 4.125 4.125z"
      />
      <path
        fill={color}
        d="M4.875 22v-1.5a1.126 1.126 0 0 1 2.25 0V22a1.125 1.125 0 1 1-2.25 0m12 0v-1.5a1.126 1.126 0 0 1 2.25 0V22a1.125 1.125 0 1 1-2.25 0M18 15.376a1.125 1.125 0 0 1 0 2.25h-4a1.125 1.125 0 0 1 0-2.25zM10.873 12.5V7a1.126 1.126 0 0 1 2.25 0v5.5a1.125 1.125 0 1 1-2.25 0M5.094 1.304a1.126 1.126 0 0 1 1.77 1.392A6.9 6.9 0 0 0 5.419 7.58l.041.349.012.114a1.125 1.125 0 0 1-2.216.32l-.022-.115-.054-.463a9.15 9.15 0 0 1 1.914-6.482Zm12.232-.189a1.125 1.125 0 0 1 1.503.103l.076.086.278.374a9.15 9.15 0 0 1 1.584 6.571l-.024.114a1.125 1.125 0 0 1-2.204-.433l.04-.349a6.9 6.9 0 0 0-1.233-4.604l-.21-.281-.067-.094a1.127 1.127 0 0 1 .257-1.487m-9.01 2.577a1.125 1.125 0 0 1 1.691 1.478l-.168.239a2.9 2.9 0 0 0-.444 1.658l.026.291.01.116a1.125 1.125 0 0 1-2.214.318l-.022-.113-.03-.26a5.14 5.14 0 0 1 1.074-3.64zm5.865-.103a1.126 1.126 0 0 1 1.504.103l.076.086.155.211a5.14 5.14 0 0 1 .89 3.69l-.022.113a1.125 1.125 0 0 1-2.205-.434l.026-.291a2.9 2.9 0 0 0-.443-1.658l-.17-.239-.066-.094a1.126 1.126 0 0 1 .255-1.487"
      />
    </svg>
  );
}
